import * as React from "react";
import { Route, Switch, RouteComponentProps } from "react-router-dom";
import LogsPage from "./LogsPage";
import AccessLogsPage from "./AccessLogsPage";
import CPQLogPage from "./CPQLogPage";

type TParams = { id: string; url: string };

function Notification({ match }: RouteComponentProps<TParams>) {
  return (
    <Switch>
      <Route exact path={`${match.url}/error`} component={LogsPage} />
      <Route exact path={`${match.url}/cs`} component={AccessLogsPage} />
      <Route exact path={`${match.url}/cpq`} component={CPQLogPage} />
    </Switch>
  );
}

export default Notification;
